import { createEffect } from "effector"
import { API } from "../API"
import { IBonusAcc } from "../types/user";


export const getCard = createEffect(async () => {
    const res = await API.card.get();
    
    return res;
})

export const saveCard = createEffect(async (value:string):Promise<IBonusAcc> => {
    const res = await API.card.save(value);

    return res;
})

export const changeCard = createEffect(async (value:string):Promise<IBonusAcc> => {
    const res = await API.card.change(value);

    return res;
})

export const deleteCard = createEffect(async ():Promise<IBonusAcc> => {
    const res = await API.card.delete();

    return res;
})